import { federalReviewActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [federalReviewActions.loadSuccess]: (state, action) => {
        return action.payload.entities.federalReviewMsgAdmissions;
    },
    [federalReviewActions.replySuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.mxno === action.payload ) {
                delete state[x.epno];
            }
        })
    },
    [federalReviewActions.closeNotificationSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.mxno === action.payload.mxno ) {
                delete state[x.epno];
            }
        })
    },

})


